import React, { useState, useEffect, useContext } from "react";
import {
    Box,
    Button,
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Typography,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
    IconButton,
} from "@mui/material";
import {
    Save,
    Edit as EditIcon,
    Check as CheckIcon,
    Close as CloseIcon,
} from "@mui/icons-material";
import { Month } from "../../OtherData/Month";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { PaymentContext } from "../../GetData/Context/PaymentContext";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { Edit, Check, Close } from "@mui/icons-material";
import { AddActionsButton, AddLinkButton } from "../../Components/AddElementsButton";

export default function AddAutomaticWages() {
    const [selectedMonth, setSelectedMonth] = useState("");
    const [endOfMonthDate, setEndOfMonthDate] = useState("");
    const [paymentDate, setPaymentDate] = useState("");
    const [paymentMethod, setPaymentMethod] = useState();
    const [comment, setComment] = useState("");
    const [payrollData, setPayrollData] = useState([]);
    const [isGenerating, setIsGenerating] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [editingRowId, setEditingRowId] = useState(null);

    const [allEmployeers, setAllEmployeers] = useState([]);


    const { fiscalYear } = useContext(FiscalYearContext);
    const { paymentsOptions } = useContext(PaymentContext);
    const headers = authHeader();


    const fetchAllEmployers = async () => {
        try {
            const response = await axios.get(ApiLink.API_URL + "Wages/allEmployeeContract", { headers });
            setAllEmployeers(response.data);
        }
        catch {
            errorAlert("Gabim gjate marrjes se te dhenave");
        }
    }


    useEffect(() => {
        if (selectedMonth) {
            const [year, month] = selectedMonth.split("-");
            const lastDay = new Date(parseInt(year), parseInt(month), 0).getDate();
            setEndOfMonthDate(`${year}-${month}-${String(lastDay).padStart(2, "0")}`);

            const payDate = new Date(parseInt(year), parseInt(month), lastDay + 5);
            // setPaymentDate(payDate.toISOString().split("T")[0]);
            setPaymentDate(`${year}-${month}-${String(lastDay).padStart(2, "0")}`);

        }
    }, [selectedMonth]);

    const generatePayroll = async () => {
        setIsGenerating(true);
        try {
            // const employees = await Employee.filter({ isActive: true });

            const rows = allEmployeers.map(emp => {
                const wages = calculateWages(emp.EmployeeRole === "Primare" ? 1 : 2, emp.SalaryNet, emp.bonuses || 0);

                return {
                    employeeId: emp.AccountID,
                    firstName: emp.AccountName,
                    grossSalary: wages.bruto,
                    netSalary: emp.SalaryNet,
                    bonuses: emp.bonuses || 0,
                    employeeType: emp.EmployeeRole || "Primare",
                    hoursPerWeek: emp.WorkingHoursPerWeek,
                    paymentMethod: paymentMethod,
                    kontributiPundhenesit: wages.kontributiPunedhenesit,
                    kontributiPunetorit: wages.kontributiPunetorit,
                    tatimiNePage: wages.tatimiNePage
                };
            });

            setPayrollData(rows);
        } catch (err) {
            console.error("Error generating payroll", err);
        } finally {
            setIsGenerating(false);
        }
    };

    const calculateWages = (llojiPages, pagaNeto, bonuse) => {
        let Deri80 = 80, Deri250 = 0, Deri450 = 0, Mbi450 = 0;
        let Koeficienti1 = 0, Koeficienti2 = 0, Koeficienti3 = 0;
        let TatimiPagaNeto = 0;
        let kontributiPunedhenesit = 0, kontributiPunetorit = 0;
        let bruto = 0;

        let pagaNetoKalkulim = Number(pagaNeto) + Number(bonuse);

        if (llojiPages === 1) {
            if (pagaNetoKalkulim <= 80) Deri80 = pagaNetoKalkulim;
            else {
                Deri80 = 80;
                if (((Number(pagaNetoKalkulim) - Number(Deri80))) <= 170) {
                    Deri250 = (Number(pagaNetoKalkulim) - Number(Deri80)) / 0.96;
                    Koeficienti1 = 0;
                } else {
                    Deri250 = 170;
                    Koeficienti1 = 0;
                    if (((Number(pagaNetoKalkulim) + Koeficienti1 - 250) / 0.92) <= 200) {
                        Deri450 = (Number(pagaNetoKalkulim) + Koeficienti1 - 250) / 0.92;
                        Koeficienti2 = Deri450 * 0.08;
                    } else {
                        Deri450 = 200;
                        Koeficienti2 = Deri450 * 0.08;
                        Mbi450 = (Number(pagaNetoKalkulim) + Koeficienti1 + Koeficienti2 - 450) / 0.9;
                        Koeficienti3 = Mbi450 * 0.1;
                    }
                }
            }

            TatimiPagaNeto = Koeficienti1 + Koeficienti2 + Koeficienti3 + Number(pagaNetoKalkulim);
            bruto = TatimiPagaNeto / 0.95;
            let kontributet = (bruto - TatimiPagaNeto) * 2;

            kontributiPunedhenesit = kontributet / 2;
            kontributiPunetorit = kontributet / 2;
        }

        if (llojiPages === 2) {
            Mbi450 = pagaNetoKalkulim / 0.9;
            Koeficienti3 = Mbi450 * 0.1;
            TatimiPagaNeto = Koeficienti3 + Number(pagaNetoKalkulim);

            bruto = TatimiPagaNeto / 0.95;
            let kontributet = (bruto - TatimiPagaNeto) * 2;

            kontributiPunedhenesit = kontributet / 2;
            kontributiPunetorit = kontributet / 2;
        }

        return {
            tatimiNePage: Koeficienti1 + Koeficienti2 + Koeficienti3,
            kontributiPunedhenesit,
            kontributiPunetorit,
            bruto
        };
    };

    const startEditing = (employeeId) => {
        setEditingRowId(employeeId);
    };

    const cancelEditing = () => {
        setEditingRowId(null);
    };

    const saveRowEdit = (employeeId) => {
        setEditingRowId(null);
    };

    const updateRowData = (employeeId, field, value) => {
        setPayrollData((prev) =>
            prev.map((row) =>
                row.employeeId === employeeId ? { ...row, [field]: value } : row
            )
        );
    };

    const handleBonusesKeyUp = (employeeId, bonuses) => {
        setPayrollData((prev) =>
            prev.map((row) => {
                if (row.employeeId === employeeId) {
                    const wages = calculateWages(
                        row.employeeType === "Primare" ? 1 : 2,
                        row.netSalary,
                        Number(bonuses || 0)
                    );

                    return {
                        ...row,
                        bonuses: Number(bonuses || 0), // ruaj vlerën e bonusit
                        kontributiPundhenesit: wages.kontributiPunedhenesit,
                        kontributiPunetorit: wages.kontributiPunetorit,
                        tatimiNePage: wages.tatimiNePage,
                        grossSalary: wages.bruto
                    };
                }
                return row;
            })
        );
    };

    const totals = {
        totalGross: payrollData.reduce((s, r) => s + r.grossSalary, 0),
        totalNet: payrollData.reduce((s, r) => s + r.netSalary, 0),
        totalBonuses: payrollData.reduce((s, r) => s + r.bonuses, 0),
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsSaving(true);

        const transactionsToSend = payrollData.map(emp => ({
            Date: endOfMonthDate, // ose ndonjë datë që duhet
            PayDate: paymentDate, // ose emp.PayDate nëse ke
            InvoiceNr: selectedMonth,
            SupplierID: emp.employeeId,
            Amount0: emp.netSalary,
            Amount18: emp.grossSalary,
            Amount8: emp.bonuses || 0,
            Total: emp.grossSalary, // ose brut + bonuses
            AccountIDSpare: emp.employeeType === "Primare" ? 1 : 2, // shembull
            PaymentOptions: emp.paymentMethod, // nëse është numerik
            TransactionType: 4, // nëse është fiks
            Coment: "",
            Comment: "",
            CompanyID: emp.companyId || 1, // siguro që ke CompanyID
            CompanyUnitID: emp.companyUnitId || null,
            LedgerID: emp.ledgerId || 0, // nëse ke LedgerID
            Debit: 0,
            Credit: 0
        }));
        axios.post(ApiLink.API_URL + 'Wages/automaticWages', transactionsToSend, { headers })
            .then(() => {
                handleSuccess("Wages Added Successfully");
                setSelectedMonth("");
                setEndOfMonthDate("");
                setPaymentDate("");
                setPaymentMethod(0);
                setComment("");
                setPayrollData([]);
                setIsSaving(false);
            })
            .catch((error) => {
                // setInsertingTransaction(false);
                // console.error(error);
                setIsSaving(false);
                if (error.response && error.response.status === 409) {
                    // setInsertingTransaction(false);
                    errorAlert(error.response.data);
                    setIsSaving(false);
                } else {
                    setIsSaving(false);
                    // setInsertingTransaction(false);
                    // errorAlert("An unknown error occurred while processing the request.");
                }
            });
    }

    useEffect(() => {
        fetchAllEmployers();
    }, []);

    return (
        <Box p={3}>
            {/* <Typography variant="h4" gutterBottom>
                Generate Payroll
            </Typography> */}

            {/* Payroll Form */}
            <Card>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <CardHeader title="Gjenero pagat automatike" />

                    <AddLinkButton
                        text="Mbyll"
                        link="/expences/wages"
                    />
                    {/* <Button
                        sx={{ mt: 2 }}
                        variant="contained"
                        onClick={generatePayroll}
                    >
                        Mbyll
                    </Button> */}
                </div>
                <CardContent>
                    <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                        <FormControl fullWidth>
                            <InputLabel>Muaji</InputLabel>
                            <Select
                                value={selectedMonth}
                                label="Muaji"
                                onChange={(e) => setSelectedMonth(e.target.value)}
                            >
                                {/* {months.map((m) => (
                                    <MenuItem key={m.value} value={m.value}>
                                        {m.label}
                                    </MenuItem>
                                ))} */}
                                {Month?.map((data) => (
                                    <MenuItem key={data.id} value={`${fiscalYear}${data.month}`}>
                                        {fiscalYear}{data.month}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <TextField
                            label="Data"
                            type="date"
                            value={endOfMonthDate}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ readOnly: true }}
                            disabled
                        />

                        <TextField
                            label="Data Pagesës"
                            type="date"
                            value={paymentDate}
                            onChange={(e) => setPaymentDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />

                        <FormControl fullWidth>
                            <InputLabel>Mënyra e pagesës</InputLabel>
                            <Select
                                value={paymentMethod}
                                label="Mënyra e pagesës"
                                onChange={(e) => setPaymentMethod(e.target.value)}
                            >
                                <MenuItem key="0" value="0">Pagesa Behet më vonë</MenuItem>
                                {paymentsOptions.map((pm) => (
                                    <MenuItem key={pm.AccountID} value={pm.AccountID}>
                                        {pm.AccountName}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>

                    <TextField
                        label="Përshkrim"
                        multiline
                        rows={3}
                        fullWidth
                        sx={{ mt: 2 }}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />

                    <Button
                        sx={{ mt: 2 }}
                        variant="contained"
                        onClick={generatePayroll}
                        disabled={!selectedMonth || !paymentMethod || isGenerating}
                    >
                        {isGenerating ? "Duke u gjeneruar..." : "Gjenero Pagat"}
                    </Button>
                </CardContent>
            </Card>
            {payrollData.length > 0 && (

                <TableContainer component={Paper}>
                    <CardHeader
                        title={`Pagat duke u procesuar (${payrollData.length} të punësuar)`}
                        subheader={`Total Bruto: $${totals.totalGross.toLocaleString()} | Total Neto: $${totals.totalNet.toLocaleString()} | Total Bonuse: $${totals.totalBonuses.toLocaleString()}`}
                    />
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Emri i të punësuarit</TableCell>
                                <TableCell>Paga Bruto</TableCell>
                                <TableCell>Paga Neto</TableCell>
                                <TableCell>Kontributi Punëdhënësit</TableCell>
                                <TableCell>Kontributi i punëtorit</TableCell>
                                <TableCell>Tatimi në pagë</TableCell>
                                <TableCell>Bonuset</TableCell>
                                {/* <TableCell>Mënyra pagesës</TableCell> */}
                                <TableCell>Prioriteti Pagës</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {payrollData.map((row) => (
                                <TableRow key={row.employeeId}>
                                    <TableCell>{row.firstName}</TableCell>
                                    <TableCell>{row.grossSalary.toLocaleString()}</TableCell>
                                    <TableCell>{row.netSalary.toLocaleString()}</TableCell>
                                    <TableCell>{row.kontributiPundhenesit.toLocaleString()}</TableCell>
                                    <TableCell>{row.kontributiPunetorit.toLocaleString()}</TableCell>
                                    <TableCell>{row.tatimiNePage.toLocaleString()}</TableCell>

                                    <TableCell>
                                        {editingRowId === row.employeeId ? (
                                            <TextField
                                                // type="number"
                                                value={row.bonuses}
                                                // onChange={(e) =>
                                                //     updateRowData(row.employeeId, "bonuses", parseFloat(e.target.value) || 0, row.netSalary, row.EmployeeRole)
                                                // }
                                                onChange={(e) =>
                                                    updateRowData(row.employeeId, "bonuses", parseFloat(e.target.value) || 0)
                                                }
                                                onKeyUp={(e) => handleBonusesKeyUp(row.employeeId, e.target.value)}
                                                variant="outlined"
                                                size="small"
                                            />
                                        ) : (
                                            `${row.bonuses.toLocaleString()}`
                                        )}
                                    </TableCell>

                                    <TableCell>{row.employeeType}</TableCell>
                                    <TableCell>
                                        {editingRowId === row.employeeId ? (
                                            <>
                                                <IconButton onClick={() => saveRowEdit(row.employeeId)} color="primary">
                                                    <Check />
                                                </IconButton>
                                                <IconButton onClick={cancelEditing} color="error">
                                                    <Close />
                                                </IconButton>
                                            </>
                                        ) : (
                                            <IconButton onClick={() => startEditing(row.employeeId)} color="primary">
                                                <Edit />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                    <div style={{ marginTop: 16, display: "flex", justifyContent: "flex-end" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleSubmit}
                            disabled={isSaving}
                            startIcon={<Save />}
                        >
                            {isSaving ? "Duke u insertuar..." : "Ruaj pagat"}
                        </Button>
                    </div>

                </TableContainer>
            )}
        </Box>
    );
}
